/*
  Midnight JPN - vehicle fitment data for the Year/Make/Model search.
  Factory wheel specs are approximate and used only to compare against wheel titles.
  Format: [make, model, yearFrom, yearTo, [bolt patterns], frontWidth, frontOffset, rearWidth, rearOffset, minDiameter, maxDiameter, smallestFactoryDiameter]
  minDiameter = smallest wheel that clears the brakes (smaller wheels are hidden).
  smallestFactoryDiameter = smallest wheel size the vehicle came with from the factory (base trim).
    Wheels this size or larger can be Direct Fit. Smaller wheels show under May Fit with a disclaimer.
  To add or fix a vehicle, edit or add a line below.
*/
window.MJ_VEHICLES = [
  /* ---------- BMW 5x120 ---------- */
  ["BMW", "3 Series (E46)", 1999, 2006, ["5x120"], 8, 47, 8.5, 50, 16, 19, 16],
  ["BMW", "M3 (E46)", 2001, 2006, ["5x120"], 8, 47, 9, 26, 18, 19, 18],
  ["BMW", "1 Series (E82/E88)", 2008, 2013, ["5x120"], 7.5, 49, 8.5, 52, 17, 19, 17],
  ["BMW", "1M Coupe (E82)", 2011, 2011, ["5x120"], 9, 37, 10, 40, 19, 19, 19],
  ["BMW", "3 Series (E90/E92/E93)", 2006, 2013, ["5x120"], 8, 34, 8.5, 37, 16, 19, 16],
  ["BMW", "M3 (E90/E92/E93)", 2008, 2013, ["5x120"], 8.5, 29, 9.5, 23, 18, 20, 18],
  ["BMW", "2 Series (F22/F23)", 2014, 2021, ["5x120"], 7.5, 45, 8, 52, 17, 19, 17],
  ["BMW", "M2 (F87)", 2016, 2021, ["5x120"], 9, 29, 10, 40, 19, 20, 19],
  ["BMW", "3 Series (F30/F31/F34)", 2012, 2019, ["5x120"], 8, 34, 8.5, 47, 17, 20, 17],
  ["BMW", "4 Series (F32/F33/F36)", 2014, 2020, ["5x120"], 8, 34, 8.5, 47, 17, 20, 17],
  ["BMW", "M3 (F80)", 2015, 2018, ["5x120"], 9, 29, 10, 40, 18, 20, 18],
  ["BMW", "M4 (F82/F83)", 2015, 2020, ["5x120"], 9, 29, 10, 40, 18, 20, 18],
  ["BMW", "5 Series (E60/E61)", 2004, 2010, ["5x120"], 8, 20, 9, 18, 17, 19, 17],
  ["BMW", "5 Series (F10/F11)", 2011, 2016, ["5x120"], 8, 30, 9, 44, 17, 20, 17],
  ["BMW", "6 Series (F06/F12/F13)", 2012, 2018, ["5x120"], 8.5, 33, 9, 44, 18, 20, 18],
  ["BMW", "7 Series (F01/F02)", 2009, 2015, ["5x120"], 8.5, 25, 9.5, 39, 18, 21, 18],
  ["BMW", "X1 (E84)", 2012, 2015, ["5x120"], 8, 34, 8, 34, 17, 19, 17],
  ["BMW", "X3 (E83)", 2004, 2010, ["5x120"], 8, 46, 8, 46, 17, 19, 17],
  ["BMW", "X3 (F25)", 2011, 2017, ["5x120"], 8, 43, 8, 43, 17, 20, 17],
  ["BMW", "X4 (F26)", 2015, 2018, ["5x120"], 8.5, 38, 9.5, 48, 18, 20, 18],
  ["BMW", "X5 (E70)", 2007, 2013, ["5x120"], 8.5, 46, 8.5, 46, 18, 21, 18],
  ["BMW", "X5 (F15)", 2014, 2018, ["5x120"], 8.5, 46, 8.5, 46, 18, 21, 18],
  ["BMW", "X6 (E71/F16)", 2008, 2019, ["5x120"], 9, 48, 10, 21, 19, 21, 19],
  ["BMW", "Z4 (E89)", 2009, 2016, ["5x120"], 8, 29, 8.5, 40, 17, 19, 17],
  /* ---------- BMW 5x112 (G-chassis) ---------- */
  ["BMW", "2 Series Coupe (G42)", 2022, 2026, ["5x112"], 8, 27, 8.5, 40, 18, 19, 18],
  ["BMW", "M2 (G87)", 2023, 2026, ["5x112"], 9.5, 20, 10.5, 20, 19, 20, 19],
  ["BMW", "3 Series (G20/G21)", 2019, 2026, ["5x112"], 8, 27, 8.5, 40, 17, 20, 17],
  ["BMW", "4 Series (G22/G23/G26)", 2021, 2026, ["5x112"], 8, 27, 8.5, 40, 18, 20, 18],
  ["BMW", "M3 (G80)", 2021, 2026, ["5x112"], 9.5, 20, 10.5, 20, 18, 20, 18],
  ["BMW", "M4 (G82/G83)", 2021, 2026, ["5x112"], 9.5, 20, 10.5, 20, 18, 20, 18],
  ["BMW", "5 Series (G30)", 2017, 2023, ["5x112"], 8, 27, 9, 44, 18, 20, 18],
  ["BMW", "7 Series (G11/G12)", 2016, 2022, ["5x112"], 8.5, 25, 9.5, 39, 18, 21, 18],
  ["BMW", "X3 (G01)", 2018, 2024, ["5x112"], 8, 33, 8, 33, 18, 21, 18],
  ["BMW", "X4 (G02)", 2019, 2025, ["5x112"], 8, 33, 9, 43, 19, 21, 19],
  ["BMW", "X5 (G05)", 2019, 2026, ["5x112"], 9, 37, 9, 37, 19, 22, 19],
  ["BMW", "Z4 (G29)", 2019, 2026, ["5x112"], 8, 29, 9, 40, 18, 19, 18],
  /* ---------- Mercedes-Benz 5x112 ---------- */
  ["Mercedes-Benz", "C-Class (W204)", 2008, 2014, ["5x112"], 7.5, 47, 8.5, 54, 17, 19, 17],
  ["Mercedes-Benz", "C-Class (W205)", 2015, 2021, ["5x112"], 7.5, 44, 8.5, 49, 17, 20, 17],
  ["Mercedes-Benz", "E-Class (W212)", 2010, 2016, ["5x112"], 8.5, 48, 9.5, 54, 17, 20, 17],
  ["Mercedes-Benz", "E-Class (W213)", 2017, 2023, ["5x112"], 8, 41, 9, 42, 18, 20, 18],
  ["Mercedes-Benz", "S-Class (W222)", 2014, 2020, ["5x112"], 8.5, 38, 9.5, 41, 18, 21, 18],
  ["Mercedes-Benz", "CLS (C218)", 2012, 2018, ["5x112"], 8.5, 38, 9.5, 42, 18, 20, 18],
  /* ---------- Audi / VW / Toyota 5x112 ---------- */
  ["Audi", "A4 / S4 (B8)", 2009, 2016, ["5x112"], 8, 43, 8, 43, 17, 20, 17],
  ["Audi", "A4 / S4 (B9)", 2017, 2026, ["5x112"], 8.5, 35, 8.5, 35, 17, 20, 17],
  ["Audi", "A5 / S5 (B8)", 2008, 2017, ["5x112"], 8.5, 32, 8.5, 32, 18, 20, 18],
  ["Audi", "A5 / S5 (B9)", 2018, 2026, ["5x112"], 8.5, 32, 8.5, 32, 18, 20, 18],
  ["Audi", "A6 / S6 (C7)", 2012, 2018, ["5x112"], 8.5, 43, 8.5, 43, 18, 21, 18],
  ["Volkswagen", "Golf / GTI (Mk6-Mk8)", 2010, 2026, ["5x112"], 7.5, 49, 7.5, 49, 17, 19, 17],
  ["Volkswagen", "Golf R", 2012, 2026, ["5x112"], 8, 50, 8, 50, 18, 19, 18],
  ["Volkswagen", "Jetta / GLI", 2011, 2026, ["5x112"], 7.5, 49, 7.5, 49, 17, 19, 17],
  ["Toyota", "GR Supra", 2020, 2026, ["5x112"], 9, 32, 10, 40, 18, 19, 18],
  /* ---------- 5x114.3 ---------- */
  ["Acura", "RSX", 2002, 2006, ["5x114.3"], 7, 45, 7, 45, 16, 18, 16],
  ["Acura", "TSX", 2004, 2014, ["5x114.3"], 8, 55, 8, 55, 17, 19, 17],
  ["Acura", "TLX", 2015, 2020, ["5x114.3"], 8, 55, 8, 55, 17, 20, 17],
  ["Acura", "Integra", 2023, 2026, ["5x114.3"], 8, 50, 8, 50, 17, 19, 17],
  ["Honda", "Civic", 2006, 2015, ["5x114.3"], 7, 45, 7, 45, 16, 19, 16],
  ["Honda", "Civic / Civic Si", 2016, 2026, ["5x114.3"], 8, 50, 8, 50, 16, 19, 16],
  ["Honda", "Accord", 2008, 2026, ["5x114.3"], 8, 55, 8, 55, 17, 20, 17],
  ["Toyota", "Camry", 2012, 2017, ["5x114.3"], 7, 45, 7, 45, 17, 19, 17],
  ["Toyota", "Camry", 2018, 2026, ["5x114.3"], 8, 40, 8, 40, 17, 20, 17],
  ["Lexus", "IS", 2006, 2026, ["5x114.3"], 8, 45, 8.5, 50, 17, 19, 17],
  ["Lexus", "RC", 2015, 2026, ["5x114.3"], 8, 45, 9, 45, 18, 19, 18],
  ["Lexus", "GS", 2013, 2020, ["5x114.3"], 8, 45, 8.5, 50, 18, 19, 18],
  ["Lexus", "ES", 2013, 2026, ["5x114.3"], 8, 40, 8, 40, 17, 19, 17],
  ["Nissan", "350Z", 2003, 2008, ["5x114.3"], 8, 30, 8.5, 33, 17, 19, 17],
  ["Nissan", "370Z", 2009, 2020, ["5x114.3"], 9, 15, 10, 30, 18, 20, 18],
  ["Nissan", "Altima", 2013, 2026, ["5x114.3"], 7.5, 45, 7.5, 45, 17, 19, 17],
  ["Nissan", "Maxima", 2016, 2023, ["5x114.3"], 8, 45, 8, 45, 18, 20, 18],
  ["Infiniti", "G35 Coupe", 2003, 2007, ["5x114.3"], 8, 30, 8.5, 33, 17, 19, 17],
  ["Infiniti", "G37 / Q60 Coupe", 2008, 2015, ["5x114.3"], 8.5, 43, 9, 45, 18, 19, 18],
  ["Infiniti", "Q50", 2014, 2024, ["5x114.3"], 8.5, 43, 8.5, 43, 17, 20, 17],
  ["Infiniti", "Q60", 2017, 2022, ["5x114.3"], 8.5, 43, 8.5, 43, 19, 20, 19],
  ["Hyundai", "Genesis Coupe", 2010, 2016, ["5x114.3"], 8.5, 45, 9.5, 50, 18, 19, 18],
  ["Hyundai", "Veloster N", 2019, 2022, ["5x114.3"], 8, 55, 8, 55, 18, 19, 18],
  ["Hyundai", "Elantra N", 2022, 2026, ["5x114.3"], 8, 55, 8, 55, 18, 19, 19],
  ["Hyundai", "Sonata", 2015, 2026, ["5x114.3"], 7.5, 50, 7.5, 50, 17, 19, 17],
  ["Genesis", "G70", 2019, 2026, ["5x114.3"], 8, 40, 8.5, 45, 18, 20, 18],
  ["Kia", "Stinger", 2018, 2023, ["5x114.3"], 8, 40, 8.5, 45, 18, 20, 18],
  ["Kia", "Optima / K5", 2016, 2026, ["5x114.3"], 7.5, 45, 7.5, 45, 17, 19, 17],
  ["Mazda", "Mazda3", 2010, 2026, ["5x114.3"], 7, 50, 7, 50, 16, 19, 16],
  ["Mazda", "Mazda6", 2014, 2021, ["5x114.3"], 7.5, 45, 7.5, 45, 17, 19, 17],
  ["Mazda", "RX-8", 2004, 2011, ["5x114.3"], 8, 50, 8, 50, 18, 19, 18],
  ["Subaru", "WRX", 2015, 2026, ["5x114.3"], 8.5, 55, 8.5, 55, 17, 19, 17],
  ["Subaru", "WRX STI", 2008, 2021, ["5x114.3"], 8.5, 53, 8.5, 53, 18, 19, 18],
  ["Mitsubishi", "Lancer Evolution X", 2008, 2015, ["5x114.3"], 8.5, 38, 8.5, 38, 18, 19, 18],
  ["Ford", "Mustang", 2015, 2026, ["5x114.3"], 9, 40, 9.5, 45, 18, 20, 18],
  ["Tesla", "Model 3", 2017, 2026, ["5x114.3"], 8.5, 40, 8.5, 40, 18, 20, 18],
  ["Tesla", "Model Y", 2020, 2026, ["5x114.3"], 9.5, 45, 9.5, 45, 19, 21, 19],
  /* ---------- 5x120 (non-BMW) ---------- */
  ["Acura", "TL", 2009, 2014, ["5x120"], 8, 55, 8, 55, 17, 19, 17],
  ["Honda", "Civic Type R", 2017, 2021, ["5x120"], 8.5, 60, 8.5, 60, 19, 20, 20],
  ["Honda", "Odyssey", 2011, 2026, ["5x120"], 7.5, 55, 7.5, 55, 17, 20, 17],
  ["Honda", "Pilot", 2009, 2026, ["5x120"], 8, 55, 8, 55, 18, 20, 18],
  ["Chevrolet", "Camaro", 2010, 2015, ["5x120"], 8, 23, 9, 35, 18, 20, 18],
  ["Chevrolet", "Camaro", 2016, 2024, ["5x120"], 8.5, 35, 9.5, 27, 18, 20, 18],
  ["Tesla", "Model S", 2012, 2020, ["5x120"], 8, 40, 8, 40, 19, 21, 19],
  /* ---------- 5x115 ---------- */
  ["Dodge", "Charger", 2011, 2023, ["5x115"], 9, 20, 9, 20, 18, 20, 18],
  ["Dodge", "Challenger", 2011, 2023, ["5x115"], 9, 20, 9, 20, 18, 20, 18],
  ["Dodge", "Challenger Widebody", 2018, 2023, ["5x115"], 11, 20, 11, 20, 20, 20, 20],
  ["Chrysler", "300", 2011, 2023, ["5x115"], 8, 24, 8, 24, 17, 20, 17],
  /* ---------- 5x100 / 5x108 / 5x130 ---------- */
  ["Scion", "FR-S", 2013, 2016, ["5x100"], 7, 48, 7, 48, 17, 18, 17],
  ["Toyota", "86 / GR86", 2017, 2026, ["5x100"], 7.5, 48, 7.5, 48, 17, 18, 17],
  ["Subaru", "BRZ", 2013, 2026, ["5x100"], 7.5, 48, 7.5, 48, 17, 18, 17],
  ["Subaru", "WRX", 2008, 2014, ["5x100"], 7.5, 53, 7.5, 53, 17, 18, 17],
  ["Ford", "Focus ST", 2013, 2018, ["5x108"], 8, 55, 8, 55, 18, 19, 18],
  ["Porsche", "911 (997)", 2005, 2012, ["5x130"], 8, 57, 10, 47, 18, 19, 18],
  ["Porsche", "Boxster / Cayman (987)", 2005, 2012, ["5x130"], 8, 57, 9.5, 46, 17, 19, 17],
  /* ---------- 6x139.7 trucks & SUVs ---------- */
  ["Chevrolet", "Silverado 1500", 2007, 2018, ["6x139.7"], 8.5, 31, 8.5, 31, 17, 24, 17],
  ["Chevrolet", "Silverado 1500", 2019, 2026, ["6x139.7"], 9, 24, 9, 24, 17, 24, 17],
  ["Chevrolet", "Tahoe / Suburban", 2007, 2020, ["6x139.7"], 8.5, 31, 8.5, 31, 17, 24, 17],
  ["Chevrolet", "Tahoe / Suburban", 2021, 2026, ["6x139.7"], 9, 28, 9, 28, 18, 24, 18],
  ["GMC", "Sierra 1500", 2007, 2018, ["6x139.7"], 8.5, 31, 8.5, 31, 17, 24, 17],
  ["GMC", "Sierra 1500", 2019, 2026, ["6x139.7"], 9, 24, 9, 24, 17, 24, 17],
  ["GMC", "Yukon / Yukon XL", 2007, 2020, ["6x139.7"], 8.5, 31, 8.5, 31, 18, 24, 18],
  ["GMC", "Yukon / Yukon XL", 2021, 2026, ["6x139.7"], 9, 28, 9, 28, 20, 24, 20],
  ["Cadillac", "Escalade", 2007, 2020, ["6x139.7"], 9, 31, 9, 31, 18, 24, 18],
  ["Cadillac", "Escalade", 2021, 2026, ["6x139.7"], 9, 28, 9, 28, 20, 24, 22]
];

/* Wheel vendors that count as the same brand as the vehicle make (shown first). */
window.MJ_OWN_BRANDS = {
  "BMW": ["bmw", "alpina"],
  "Mercedes-Benz": ["mercedes benz", "mercedes-benz", "mercedes", "amg", "maybach"],
  "Chevrolet": ["chevrolet", "chevy"],
  "Volkswagen": ["volkswagen", "vw"]
};

/* Vendors that are car makers. Any wheel vendor NOT on this list is treated as an aftermarket brand. */
window.MJ_OEM_VENDORS = ["acura", "alfa romeo", "alpina", "amg", "audi", "bmw", "buick", "cadillac", "chevrolet", "chevy", "chrysler", "dodge", "fiat", "ford", "genesis", "gmc", "honda", "hummer", "hyundai", "infiniti", "jaguar", "jeep", "kia", "land rover", "lexus", "lincoln", "lotus", "maybach", "mazda", "mercedes", "mercedes benz", "mercedes-benz", "mini", "mitsubishi", "nissan", "porsche", "ram", "renault", "scion", "subaru", "suzuki", "tesla", "toyota", "volkswagen", "volvo", "vw"];
